import { FC } from 'react';
import type { IPrimaryBanner } from '@belong/types';
import { PrimaryBanner as Banner } from '@belong/ui-components';

const PrimaryBanner: FC<IPrimaryBanner> = (props: IPrimaryBanner) => <Banner {...props} />;

export default PrimaryBanner;
